import { QueryClient } from 'react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 15,
      cacheTime: 1000 * 60 * 15,
      refetchInterval: false,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error?.statusCode === 429 || error?.statusCode === 404) {
          return false;
        }
        return failureCount !== 2;
      },
    },
  },
});
